export default "__VITE_ASSET__59KAZAti__"